import React, { useState, useEffect } from 'react';
import { Modal, Button, Label, Input, Alert } from 'reactstrap';
import Moment from 'react-moment';
import MobileDatePickerCalendar from './MobileDatePickerCalendar';
import moment from 'moment';

const BookingPopup = ({
  isOpen,
  toggle,
  bookingData,
  checkInDate,
  checkOutDate,
  days,
  totalAmount,
  hostel,
  hostelId,
  onReserve,
  onChange
}) => {
  const [openCalendar, setOpenCalendar] = useState(false);
  const [fromDate, setFromDate] = useState(checkInDate);
  const [toDate, setToDate] = useState(checkOutDate);

  // Update local state when props change
  useEffect(() => {
    setFromDate(checkInDate);
    setToDate(checkOutDate);
  }, [checkInDate, checkOutDate]);

  const formatDate = (date) => {
    if (!date) return '';
    return moment(date).format('DD/MM/YYYY');
  };

  const onMobileDateChange = (dates) => {
    const formattedFrom = moment(dates.fromDate, 'DD/MM/YYYY').format('YYYY-MM-DD');
    const formattedTo = moment(dates.toDate, 'DD/MM/YYYY').format('YYYY-MM-DD');
    setFromDate(formattedFrom);
    setToDate(formattedTo);
    setOpenCalendar(false);
    window.location.href = `/hostel?hostel=${hostelId}&from=${formattedFrom}&to=${formattedTo}`;
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered className="modal-dialog-centered">
      <div className="modal-content rounded-5 shadow" style={{backgroundColor:"#EBEAEA"}}>
        <div className="modal-body p-4">
        <button 
            className="position-absolute top-0 start-0 m-3 border-0 bg-light rounded"
            style={{ color: "#e10000", fontSize: "1.5rem" }}
            onClick={toggle}>
            <i className="bi bi-chevron-left"></i>
          </button>
 
          <div className="fw-bold h4 text-dark mb-3" style={{ textAlign: "center" }}>Booking Summary</div>
          <div className="fw-bold mb-3" style={{ color: "#ED452F", textAlign: "center" }}>
            {days} {days === 1 ? "Night" : "Nights"} starting from <Moment format="DD MMM YYYY">{checkInDate}</Moment>
          </div>

          <div className="row row-cols-lg-2 row-cols-1 g-3 mb-3" style={{ justifyContent: "space-evenly", gap: "2rem" }}>
            <div className="col" style={{ width: "80%" }}>
              <div className='d-flex justify-content-between w-100'>
              <Label className="fw-bold" style={{paddingLeft:"1rem"}}>Move In</Label>
              <Label className="fw-bold" style={{paddingRight:"2rem"}}>Move Out</Label>
              </div>
              <div className="d-flex justify-content-between w-100" style={{ position: 'relative' }}>
                <Input 
                  style={{width:"7.5rem"}}
                  value={formatDate(fromDate)}
                  placeholder="From"
                  type="text"
                  className="border-0 bg-light"
                  readOnly
                  onClick={() => setOpenCalendar(true)}
                />
                
                <Input
                  style={{width:"7.5rem"}}
                  value={formatDate(toDate)}
                  placeholder="To"
                  type="text"
                  className="border-0 bg-light"
                  readOnly
                  onClick={() => setOpenCalendar(true)}
                 />

                {openCalendar && (
                  <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 9999,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)'
                  }}>
                    <MobileDatePickerCalendar
                      onChange={onMobileDateChange}
                      setOpenCalendar={() => setOpenCalendar(false)}
                      openCalendar={openCalendar}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>

          {Object.keys(bookingData).length !== 0 && (
            <div>
              {Object.keys(bookingData).map((roomType, index) => (
                <div key={index} className="bg-white p-3 mb-3 shadow-sm" style={{borderRadius:"1rem"}}>
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <h6 className="mb-1 fw-bold">{roomType}</h6>
                      <div className="text-muted">
                        Rs. {bookingData[roomType].cost} × {bookingData[roomType].totalRooms} Rooms
                      </div>
                    </div>
                    <div className="fw-bold">Rs. {bookingData[roomType].cost * bookingData[roomType].totalRooms}</div>
                  </div>
                  <div className="d-flex justify-content-between">
                    <div>Discount:</div>
                    <div className="fw-bold">Rs. {bookingData[roomType].vendorDiscount?.toFixed(2)}</div>
                  </div>
                  <div className="d-flex justify-content-between">
                    <div>Tax:</div>
                    <div className="fw-bold">
                      Rs. {((bookingData[roomType].cost * bookingData[roomType].totalRooms - bookingData[roomType].vendorDiscount) * 0.12).toFixed(2)}
                    </div>
                  </div>
                  <div className="d-flex justify-content-between">
                    <div>Additional Discount:</div>
                    <div className="fw-bold">
                      Rs. {(bookingData[roomType]?.thcDiscount || 0).toFixed(2)}
                    </div>
                  </div>
                  {/* <hr className="hr mb-3" /> */}
                </div>
              ))}
              <div className="d-flex justify-content-between mb-3">
                <div className="fw-bold">Total</div>
                <div className="fw-bold">Rs. {totalAmount.toFixed(2)}</div>
              </div>
              <div className="d-flex justify-content-between mb-3">
                <div className="fw-bold">Payable Now</div>
                <div className="fw-bold">Rs. {(totalAmount * (hostel[0]?.payable_percent / 100)).toFixed(2)}</div>
              </div>
              <div className="d-flex justify-content-center"> 
              <Button className="w-50 rounded-pill mb-3" onClick={onReserve} style={{backgroundColor:"#FD590C"}} >
                Continue booking
                </Button>
              </div>
              <Alert size="sm" color="info">You can apply coupons while checkout.</Alert>
            </div>
          )}
          {Object.keys(bookingData).length === 0 && (
            <a href="#select-rooms" className="btn w-100 mb-3 bg-dark-o text-white">Select room</a>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default BookingPopup;
